import flyingTakingOff from "../../assets/icons/flying-taking-off.svg";
import flyingLanding from "../../assets/icons/flying-landing.svg";
import fuelStopIcon from "../../assets/icons/fuel-stop-dark.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import timeIcon from "../../assets/icons/time.svg";
import durationIcon from "../../assets/icons/duration.svg";
import useJourneyLegIcons from "../../hooks/useJourneyLegIcons";
import { formatJourneyLegs } from "../../utilities/journeyLeg";

/**
 * Table layout for QuoteQuery: Date | Time | From | Duration | To | Passengers | Luggage
 * Used in QuoteQueryPersonalDetails and PortalQuoteQueryPersonalDetails (layout 10)
 */
const QuoteQueryJourneyLeg = ({ legs, showFuelStop, duration, fuelStop }) => {
    const isQuotePage = window.location.pathname === "/quote";
    const { passengerIcon, luggageIcon } = useJourneyLegIcons({ isQuotePage, layout: 10 });
    const formattedLegs = formatJourneyLegs(legs, { duration, fuelStop, shortYear: true });

    return (
        <div className="journey-leg journey-leg--10">
            <table className="journey-leg__table">
                <thead className="journey-leg__table-header">
                    <tr>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <img src={calendarIcon} alt="" className="journey-leg__header-icon" />
                                Date
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <img src={timeIcon} alt="" className="journey-leg__header-icon" />
                                Time
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <img src={flyingTakingOff} alt="" className="journey-leg__header-icon" />
                                From
                            </span>
                        </th>
                        {showFuelStop && (
                            <th className="journey-leg__table-header-cell">
                                <span className="journey-leg__header-content">
                                    <img src={durationIcon} alt="" className="journey-leg__header-icon" />
                                    Duration
                                </span>
                            </th>
                        )}
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <img src={flyingLanding} alt="" className="journey-leg__header-icon" />
                                To
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <img src={passengerIcon} alt="Passengers" className="journey-leg__header-icon" />
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <img src={luggageIcon} alt="Luggage" className="journey-leg__header-icon" />
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody className="journey-leg__table-body">
                    {formattedLegs.map((leg, index) => (
                        <tr key={index} className="journey-leg__table-row">
                            <td className="journey-leg__table-cell">{leg.formattedDepartureDate}</td>
                            <td className="journey-leg__table-cell">
                                {leg.departureTime} {leg.departureTime && leg.departureTimeZone}
                            </td>
                            <td className="journey-leg__table-cell journey-leg__table-cell--location">
                                <div className="journey-leg__long-form-location">{leg.fromLong}</div>
                                {leg.fromShort && (
                                    <div className="journey-leg__short-form-location">
                                        <span className="journey-leg__code-brackets">(</span>
                                        {leg.fromShort}
                                        <span className="journey-leg__code-brackets">)</span>
                                    </div>
                                )}
                            </td>
                            {showFuelStop && (
                                <td className="journey-leg__table-cell journey-leg__table-cell--duration">
                                    {leg.fuelStop > 0 && (
                                        <img className="journey-leg__fuel-stop-icon" src={fuelStopIcon} alt="" />
                                    )}
                                    {leg.duration || "-"}
                                    {leg.fuelStop > 0 && (
                                        <>
                                            <br />
                                            <span className="journey-leg__fuel-stop-text">
                                                {leg.fuelStop === 1 ? "Fuel stop" : `${leg.fuelStop} Fuel stops`}
                                            </span>
                                        </>
                                    )}
                                </td>
                            )}
                            <td className="journey-leg__table-cell journey-leg__table-cell--location">
                                <div className="journey-leg__long-form-location">{leg.toLong}</div>
                                {leg.toShort && (
                                    <div className="journey-leg__short-form-location">
                                        <span className="journey-leg__code-brackets">(</span>
                                        {leg.toShort}
                                        <span className="journey-leg__code-brackets">)</span>
                                    </div>
                                )}
                            </td>
                            <td className="journey-leg__table-cell journey-leg__table-cell--center">
                                <span className="journey-leg__mobile-icon-wrapper">
                                    <img src={passengerIcon} alt="" className="journey-leg__mobile-icon" />
                                    {leg.passengers}
                                </span>
                            </td>
                            <td className="journey-leg__table-cell journey-leg__table-cell--center">
                                <span className="journey-leg__mobile-icon-wrapper">
                                    <img src={luggageIcon} alt="" className="journey-leg__mobile-icon" />
                                    {leg.luggage}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default QuoteQueryJourneyLeg;
